import React, { useState, useMemo, useEffect } from "react";
import { Button, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Modal, Form, Card } from "react-bootstrap";

import axios from "axios";
import { BASE_URL, IMAGE_URL, security_key } from "../../../global";
import Swal from "sweetalert2";
import LinearProgress from "@mui/material/LinearProgress";

const HighlightManagement = () => {
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [highlights, setHighlights] = useState([]);

    useEffect(() => {
        fetchAllHighlight();
    }, []);

    const fetchAllHighlight = async () => {
        setLoading(true);
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "getAllHighlightArticles",
        });

        const output = response.data;

        if (output.length > 0) {
            setHighlights(output);
        }
        setLoading(false);
    };

    const filteredHighlights = useMemo(() => {
        return highlights.filter((highlight) => {
            return highlight.ac_name.toLowerCase().includes(searchTerm.toLowerCase());
        });
    }, [highlights, searchTerm]);

    const handleDelete = async (pk_hl_key) => {
        try {
            const result = await Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, delete it",
            });

            if (result.isConfirmed) {
                const response = await axios.post(BASE_URL + "API/apicall", {
                    security_key: security_key,
                    mode: "deleteHighlightList",
                    pk_hl_key: pk_hl_key,
                });

                const output = response.data;

                if (output == 1) {
                    await Swal.fire("Deleted!", "The Highlight List Row has been successfully removed.", "success");
                    fetchAllHighlight();
                }
            }
        } catch (error) {
            console.error("An error occurred: ", error);
        }
    };

    return (
        <div className="container mt-4">
            <div className="d-flex justify-content-between align-items-center admin-page-head">
                <h4 className="mb-2">Highlight List Settings</h4>
                <Button as={Link} to="/admin/add-highlight" variant="dark" className="mb-3">
                    Add
                </Button>
            </div>
            <div className="mb-4">
                <Form>
                    <div className="row">
                        <div className="col-md-4">
                            <Form.Group>
                                <Form.Control type="text" placeholder="Search by name" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                            </Form.Group>
                        </div>
                    </div>
                </Form>
            </div>

            <div className="table-responsive">
                <Table bordered striped>
                    <thead className="thead-dark">
                        <tr>
                            <th>S.No</th>
                            <th>Article Name</th>
                            <th>Type</th>
                            <th>Order</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading && (
                            <tr>
                                <td colSpan={4} className="p-0">
                                    <LinearProgress />
                                </td>
                            </tr>
                        )}
                        {!loading && filteredHighlights.length == 0 && (
                            <tr>
                                <td colSpan={4}>
                                    <h6 className="text-center">Data not available</h6>
                                </td>
                            </tr>
                        )}
                        {filteredHighlights.map((highlight, index) => (
                            <tr key={highlight.pk_hl_key} className="border-0">
                                <td>{index + 1}</td>
                                <td>{highlight.ac_name}</td>
                                <td>{highlight.highlight_type === 1 ? "Today Highlight" : "Hot & Trending"}</td>
                                <td>{highlight.highlight_order}</td>

                                <td className="">
                                    <div className="actbtn-grp">
                                        <Button
                                            as={Link}
                                            to={`/admin/edit-highlight/${highlight.pk_hl_key}`}
                                            className="edit-icon btn btn-outline-dark"
                                            data-bs-toggle="tooltip"
                                            title="Edit"
                                        >
                                            <i class="fa-solid fa-pen-to-square"></i>
                                        </Button>
                                        <Button
                                            variant="outline-danger"
                                            size="sm"
                                            onClick={() => handleDelete(highlight.pk_hl_key)}
                                            data-bs-toggle="tooltip"
                                            title="Delete"
                                        >
                                            <i className="fa-solid fa-trash fa-lg"></i>
                                        </Button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>

            <style jsx>
                {`
                    .table-img {
                        width: 100px; /* Adjust as needed */
                        height: auto;
                    }
                    th {
                        cursor: pointer;
                    }
                    .pagination {
                        margin-top: 20px;
                    }
                    .edit-icon:hover {
                        color: #fff !important;
                    }
                    .actbtn-grp {
                        display: flex;
                        gap: 6px;
                        flex-wrap: wrap;
                    }
                `}
            </style>
        </div>
    );
};

export default HighlightManagement;
